"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDetailedPerformanceTableForTeacher = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var fixedFirstTwoColumns = "\n      > * > tr > th:first-child,\n      > * > tr > td:first-child {\n        position: sticky;\n        left: 0;\n        z-index: 2;\n      }\n\n      > * > tr > th:nth-child(2),\n      > * > tr > td:nth-child(2) {\n        position: sticky;\n        left: 230px;\n        z-index: 2;\n      }\n";
exports.StyledDetailedPerformanceTableForTeacher = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  table {\n    @media only screen and (width <= 1544px) {\n      display: block;\n      overflow-x: auto;\n      table-layout: fixed;\n      white-space: nowrap;\n\n      ", "\n    }\n  }\n\n  ", "\n"], ["\n  table {\n    @media only screen and (width <= 1544px) {\n      display: block;\n      overflow-x: auto;\n      table-layout: fixed;\n      white-space: nowrap;\n\n      ", "\n    }\n  }\n\n  ", "\n"])), fixedFirstTwoColumns, function (_a) {
    var horizontalScroll = _a.horizontalScroll, isDiagnostic = _a.isDiagnostic;
    return horizontalScroll && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      table {\n        display: block;\n        max-width: ", ";\n        overflow-x: auto;\n        table-layout: fixed;\n        white-space: nowrap;\n\n        ", "\n      }\n    "], ["\n      table {\n        display: block;\n        max-width: ", ";\n        overflow-x: auto;\n        table-layout: fixed;\n        white-space: nowrap;\n\n        ", "\n      }\n    "])), function () { return (isDiagnostic ? '1346px' : 'none'); }, fixedFirstTwoColumns);
});
var templateObject_1, templateObject_2;
